import * as React from "react";

import "./NewCallModal.css";

import { connect } from "react-redux";

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import moment from "moment-timezone";
import {
  IBroadcast,
  IProfileListQuery,
  UserID,
  LineID,
  IProfile,
} from "../api/APIClient";
import Loader from "../components/Loader";
import { RootState } from "../types";
import { UserIDInput } from "src/components/UserIDInput";
import { LineIDInput } from "src/components/LineIDInput";
import { TimeZonePicker } from "src/components/TimeZonePicker";
import {
  createBroadcast as createBroadcastAction,
  getBroadcastAudience as getBroadcastAudienceAction,
} from "src/thunks";
import { Topic } from "dialup";
import TopicPickerContainer from "src/components/TopicPicker";

interface IProps {
  initialQuery?: IProfileListQuery;
  isOpen: boolean;
  toggleOpen: () => void;

  broadcastLoading: boolean;
  createBroadcast: (cast: IBroadcast) => any;

  audience: IProfile[];
  getBroadcastAudience: (cast: IBroadcast) => IProfile[];
}

interface IState {
  isDelayed: boolean;
  selectedDay: string;
  selectedTopic?: Topic;
  selectedTime: string;
  selectedTZ: string;
  validDay: boolean;
  validTime: boolean;
  callerName: string;

  byUser: boolean;

  query: IProfileListQuery;
}

export class NewCallModal extends React.Component<IProps, IState> {
  private cast: IBroadcast;

  public constructor(props: IProps) {
    super(props);

    this.state = {
      isDelayed: true,

      callerName: "",
      selectedPrompt: undefined,

      // If we passed in a user then select it
      byUser:
        props.initialQuery &&
        props.initialQuery.users &&
        props.initialQuery.users.length > 0,

      selectedTZ: moment.tz.guess(),

      selectedDay: moment()
        .add(1, "hour")
        .format("MMM D, YYYY"),
      validDay: true,

      selectedTime: moment()
        .add(1, "hour")
        .format("LT"),
      validTime: true,

      query: {
        ...props.initialQuery,
      },
    } as IState;
  }

  public componentWillReceiveProps(props: IProps) {
    const { initialQuery } = props;

    if (
      initialQuery &&
      JSON.stringify(initialQuery) !== JSON.stringify(this.props.initialQuery)
    ) {
      this.setState({
        query: initialQuery,

        // If we passed in a user then select it
        byUser:
          !!initialQuery &&
          !!initialQuery.users &&
          initialQuery.users.length > 0,
      });
    }
  }

  public componentWillUpdate(_: any, state: IState) {
    const cast = this.makeBroadcast(state);
    if (JSON.stringify(cast) !== JSON.stringify(this.cast)) {
      this.cast = cast;
      this.props.getBroadcastAudience(cast);
    }
  }

  public render() {
    const {
      byUser,
      callerName,
      isDelayed,
      selectedDay,
      selectedTime,
      selectedTZ,
      validDay,
      validTime,
      query,
    } = this.state;
    const { isOpen, toggleOpen, broadcastLoading, audience } = this.props;

    const scheduledDate = moment.tz(
      `${selectedDay} ${selectedTime}`,
      "MMM D, YYYY LT",
      selectedTZ
    );
    const datePast = isDelayed && scheduledDate.isBefore(moment());

    let validCall = byUser ? !!query.users : !!query.lines;
    if (isDelayed) {
      validCall = validCall && validDay && validTime && !datePast;
    }

    return (
      <Modal isOpen={isOpen} toggle={toggleOpen}>
        <ModalHeader toggle={toggleOpen}>New Call</ModalHeader>
        <ModalBody>
          <form onSubmit={this.onSubmit}>
            <strong>Audience</strong>

            <div>Matches {audience.length} users</div>

            <div className="form-group row">
              <div className="col-sm-6">
                <input
                  className="form-control"
                  type="number"
                  value={query.localTimeMin}
                  onChange={this.onChangeTimeMin}
                  placeholder="Min time (eg 700)"
                  min={0}
                  max={2400}
                  maxLength={4}
                />
              </div>
              <div className="col-sm-6">
                <input
                  className="form-control"
                  type="number"
                  placeholder="Max time (eg 2100)"
                  value={query.localTimeMax}
                  onChange={this.onChangeTimeMax}
                  min={0}
                  max={2400}
                  maxLength={4}
                />
              </div>
            </div>

            <ul className="nav nav-tabs audience-nav">
              <li className="nav-item">
                <a
                  onClick={this.onClickByLine}
                  className={"nav-link" + (byUser ? " " : " active")}
                >
                  By Line
                </a>
              </li>
              <li className="nav-item">
                <a
                  onClick={this.onClickByUser}
                  className={"nav-link" + (byUser ? " active" : "")}
                  href="#"
                >
                  By User
                </a>
              </li>
            </ul>

            <div className="form-group">
              {byUser ? (
                <UserIDInput
                  onChange={this.onUsersChanged}
                  initialUsers={query.users}
                  key={query.users ? query.users.join(",") : undefined}
                />
              ) : (
                <LineIDInput
                  onChange={this.onLinesChanged}
                  lines={query.lines}
                />
              )}
            </div>
            <div className="form-group">
              <div>
                <input
                  placeholder="Caller Name"
                  onChange={this.onCallerNameChanged}
                  value={callerName}
                  className="form-control"
                />
              </div>
            </div>
            <TopicPickerContainer onSelect={this.onSelectTopic} />
            <div className="form-group">
              <strong>Schedule</strong>
              <div className="form-check">
                <input
                  checked={isDelayed}
                  onChange={this.onDelayChanged}
                  type="checkbox"
                  className="form-check-input"
                  id="delayedCallCheck"
                />
                <label htmlFor="delayedCallCheck" className="form-check-label">
                  Delayed call
                </label>
              </div>
              {isDelayed ? (
                <div className="form-group" style={{ marginTop: 10 }}>
                  <div className="row">
                    <label
                      htmlFor="inputStartDate"
                      className="col-sm-2 col-form-label"
                    >
                      Start
                    </label>
                    <div className="col-sm-4">
                      <input
                        onChange={this.onDayChanged}
                        value={selectedDay}
                        className={
                          "form-control form-control-sm" +
                          (!validDay || datePast ? " is-invalid" : "")
                        }
                        id="inputStartDate"
                      />
                    </div>
                    <div className="col-sm-3">
                      <input
                        onChange={this.onTimeChanged}
                        value={selectedTime}
                        className={
                          "form-control form-control-sm" +
                          (validTime ? "" : " is-invalid")
                        }
                      />
                    </div>
                  </div>
                  <div className="row">
                    <label
                      htmlFor="inputTimezone"
                      className="col-sm-2 col-form-label"
                    >
                      TZ
                    </label>
                    <div className="col-sm-7">
                      <TimeZonePicker
                        onChange={this.onTZChanged}
                        value={selectedTZ}
                      />
                    </div>
                  </div>
                  <div className="row text-muted">
                    <div className="col-sm-7">
                      Starts {scheduledDate.fromNow()}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <Loader visible={broadcastLoading} />
          <Button onClick={this.onSubmit} disabled={!validCall} color="primary">
            {isDelayed ? "Schedule Call" : "Call Now"}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  private onSelectTopic = (selectedTopic?: Topic) => {
    this.setState({ selectedTopic });
  };

  private onChangeTimeMax = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    const localTimeMax = parseInt(value, 10);

    const query = {
      ...this.state.query,
      localTimeMax,
    };

    this.setState({ query });
  };

  private onChangeTimeMin = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    const localTimeMin = parseInt(value, 10);

    const query = {
      ...this.state.query,
      localTimeMin,
    };

    this.setState({ query });
  };

  private onCallerNameChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    this.setState({ callerName: value });
  };

  private onDelayChanged = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ isDelayed: e.currentTarget.checked });
  };

  private onDayChanged = (e: React.FormEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    this.setState({
      selectedDay: value,
      validDay: moment(value, "MMM D, YYYY", true).isValid(),
    });
  };

  private onTimeChanged = (e: React.FormEvent<HTMLInputElement>) => {
    const { value } = e.currentTarget;
    this.setState({
      selectedTime: value,
      validTime: moment(value, "LT", true).isValid(),
    });
  };

  private onUsersChanged = (users: UserID[]) => {
    this.setState({
      query: {
        ...this.state.query,
        users,
      },
    });
  };

  private onClickByLine = () => {
    this.setState({ byUser: false });
  };

  private onClickByUser = () => {
    this.setState({ byUser: true });
  };

  private onLinesChanged = (lines: LineID[]) => {
    this.setState({
      query: {
        ...this.state.query,
        lines,
      },
    });
  };

  private makeBroadcast(state: IState) {
    const {
      byUser,
      callerName,
      isDelayed,
      selectedTopic,
      selectedDay,
      selectedTime,
      selectedTZ,
    } = state;

    const query = { ...state.query };
    if (byUser) {
      query.lines = [];
    } else {
      query.users = [];
    }

    let startMoment = moment();
    if (isDelayed) {
      startMoment = moment.tz(
        `${selectedDay} ${selectedTime}`,
        "MMM D, YYYY LT",
        selectedTZ
      );
    }

    const startTime = startMoment.format();

    const cast: IBroadcast = {
      from: callerName,
      startTime,
      query,
    };

    if (selectedTopic) {
      cast.prompt = selectedTopic.promptURL;
      cast.promptText = selectedTopic.text;
    }

    return cast;
  }

  private onSubmit = () => {
    const { createBroadcast } = this.props;

    const cast = this.makeBroadcast(this.state);

    createBroadcast(cast);
  };

  private onTZChanged = (selectedTZ: string) => {
    this.setState({ selectedTZ });
  };
}

export const NewCallContainer = connect(
  ({ calls }: RootState) => ({
    broadcastLoading: calls.isLoading,
    audience: calls.callAudience,
  }),
  dispatch => ({
    createBroadcast: (cast: IBroadcast) =>
      dispatch<any>(createBroadcastAction(cast)),
    getBroadcastAudience: (cast: IBroadcast) =>
      dispatch<any>(getBroadcastAudienceAction(cast)),
  })
)(NewCallModal);

export default NewCallContainer;



// WEBPACK FOOTER //
// ./src/pages/NewCallModal.tsx